import { render, staticRenderFns } from "./SavedProductView.vue?vue&type=template&id=065401f8"
import script from "./SavedProductView.vue?vue&type=script&lang=js"
export * from "./SavedProductView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports